import React from 'react';
import Link from 'gatsby-link';
import Newsletter from '../components/newsletter';

import './footer.scss';

import logo from '../assets/images/TFP-logo-header-white.png';
import stackedLogo from '../assets/images/TFP-logo-white.png';

export default class Footer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <footer className="footer">
                    <div className="footer__inner">
                        <Link to="/">
                            <img className="footer__logo" src={logo} />
                            <img className="footer__logo mobile" src={stackedLogo} />
                        </Link>
                        <Newsletter />

                        <div className="footer__links-container">
                            <div>
                                <Link className="footer__link" to="/about">
                                    About Us
                                </Link>
                                <a className="footer__link" href="mailto:hello@thefarmproject.com" target="_blank">
                                    Contact
                                </a>
                                <Link className="footer__link" to="/careers">
                                    Careers
                                </Link>
                            </div>
                            <div>
                                <Link className="footer__link" to="/blog">
                                    Blog
                                </Link>
                                <Link className="footer__link" to="/collaborations">
                                    Collaborations
                                </Link>
                                <a className="footer__link" href="https://www.lettucegrow.com/" target="_blank">
                                    Lettuce Grow
                                    <i className="fas fa-external-link-alt" />
                                </a>
                                <a
                                    className="footer__link"
                                    href="https://www.facebook.com/yourfoodsrootsbyattn/"
                                    target="_blank"
                                >
                                    Your Food's Roots
                                    <i className="fas fa-external-link-alt" />
                                </a>
                            </div>
                        </div>

                        <div className="footer__social">
                            <a className="social-icon" href="https://instagram.com/farmproject" target="_blank">
                                <i className="fab fa-instagram" />
                            </a>
                            <a className="social-icon" href="https://www.facebook.com/thefarmproject" target="_blank">
                                <i className="fab fa-facebook" />
                            </a>
                        </div>
                        <div className="footer__copyright">
                            Copyright &copy; 2018, The Farm Project.
                            <br />
                            <Link to="/terms">Terms of Use</Link> | <Link to="/privacy">Privacy Policy</Link>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/footer.js